const EVENTS = {
  OPEN_WIZARD_DEAL_CARD: {
    category: 'ValuationWizard',
    action: 'propertyOverview',
  },
  START_EVALUATION: {
    category: 'ValuationWizard',
    action: 'startValuation',
  },
  WIZARD_SLIDE: {
    category: 'ValuationWizard',
  },
  START_SCAN: {
    category: 'RealtorApp',
    action: 'startScan',
  },
  SAVE_SCAN: {
    category: 'RealtorApp',
    action: 'saveScan',
  },
};

export default EVENTS;
